// apps/pwa-pos/src/lib/print-setting.ts
// Sprint 37 Fase 1 — Setting "Imprimir ticket al cobrar" persistido en
// localStorage. Default `false` (no se imprime).
//
// CheckoutModal lee este flag como valor inicial y lo sobrescribe por venta
// según la elección del cajero ("Cobrar" vs "Cobrar e Imprimir").
//
// POS.4 — también persiste el adaptador preferido (`browser` por defecto).
// Bluetooth/USB quedan como extension point en ticket.ts; no se fingen.

import type { TicketPrinterKind } from './ticket';

const KEY = 'mibodega.pos.imprimir-ticket';
const ADAPTER_KEY = 'mibodega.pos.print-adapter';

function safeRead(): boolean {
  try {
    if (typeof localStorage === 'undefined') return false;
    const raw = localStorage.getItem(KEY);
    if (raw === null) return false;
    return raw === 'true';
  } catch {
    return false;
  }
}

function safeWrite(value: boolean): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(KEY, value ? 'true' : 'false');
  } catch (err) {
    console.warn('[print-setting] no se pudo persistir:', err);
  }
}

export function getPrintTicket(): boolean {
  return safeRead();
}

export function setPrintTicket(value: boolean): void {
  safeWrite(value);
}

/** Preferencia de adaptador. Solo `browser` está implementado (POS.4). */
export function getPrintAdapter(): TicketPrinterKind {
  try {
    if (typeof localStorage === 'undefined') return 'browser';
    const raw = localStorage.getItem(ADAPTER_KEY);
    if (raw === 'bluetooth' || raw === 'usb' || raw === 'browser') return raw;
    return 'browser';
  } catch {
    return 'browser';
  }
}

export function setPrintAdapter(kind: TicketPrinterKind): void {
  try {
    if (typeof localStorage === 'undefined') return;
    localStorage.setItem(ADAPTER_KEY, kind);
  } catch (err) {
    console.warn('[print-setting] no se pudo persistir adaptador:', err);
  }
}
